<nz-spin [nzSpinning]="isLoading"></nz-spin>

@if (!isLoading && data) {
  <!-- WP -->
  @if (hasWorkPermit()) {
    <div class="row">
      <div class="col col-lg-12">
        <h5 class="fs-14"><strong>Work Permit</strong></h5>
        <table class="table table-borderless mb-0">
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">Activ. Start:</td>
            <td class="pt-1 pb-0">{{ getFirstWorkPermit()?.start_date | niceDate : '-' }}</td>
          </tr>
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">Activ. End:</td>
            <td class="pt-1 pb-0">{{ getFirstWorkPermit()?.end_date | niceDate : '-' }}</td>
          </tr>
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">ID:</td>
            <td class="pt-1 pb-0">
              @if (getFirstWorkPermit()?.url) {
                <a
                  [href]="getFirstWorkPermit()?.url"
                  [title]="getFirstWorkPermit()?.id"
                  target="_blank"
                  class="clickable text-success">
                  {{ getFirstWorkPermit()?.id | nullAsWhatever : '-' }}
                </a>
              } @else {
                {{ getFirstWorkPermit()?.id | nullAsWhatever : '-' }}
              }
            </td>
          </tr>
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">Title:</td>
            <td class="pt-1 pb-0">{{ getFirstWorkPermit()?.title | nullAsWhatever : '-' }}</td>
          </tr>
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">Description:</td>
            <td class="pt-1 pb-0">
              <span
                class="wop-description"
                [innerHTML]="getFirstWorkPermit()?.description | normalizeNewLines | newLineBreaker | nullAsWhatever : '-'"></span>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="hr-separator"><hr></div>
  }

  <!-- WO -->
  <div class="row mb-3">
    <div class="col col-lg-12">
      <h5 class="fs-14"><strong>Work Order</strong></h5>

      <table class="table table-borderless mb-3">
        <tr>
          <td class="fs-12 pt-1 pb-0 w-120 align-top">ID:</td>
          <td class="pt-1 pb-0">
            @if (data.url) {
              <a [href]="data.url" [title]="data.work_order" target="_blank" class="clickable text-success">
                {{ data.work_order | nullAsWhatever : '-' }}
              </a>
            } @else {
              {{ data.work_order | nullAsWhatever : '-' }}
            }
          </td>
        </tr>
        <tr>
          <td class="fs-12 pt-1 pb-0 w-120 align-top">Title:</td>
          <td class="pt-1 pb-0">{{ data.title | nullAsWhatever : '-' }}</td>
        </tr>

        @if (data.assurances) {
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120 align-top">Activity types:</td>
            <td class="pt-1 pb-0">
              @for (activityType of getAssuranceActivityTypes(); track activityType + '-' + $index) {
                {{ activityType }}
                @if ($index < getAssuranceActivityTypes().length - 1) {
                  <br>
                }
              }
            </td>
          </tr>
        }
      </table>
    </div>

    <!-- -->
    <div class="w-100">
      <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
        <!-- DESCRIPTION -->
        <li [ngbNavItem]="1">
          <a ngbNavLink class="text-dark font-weight-bold border-start-0 square-top-left-border">Description</a>
          <ng-template ngbNavContent>
            <div class="pt-3 px-3 pe-3 pb-0 mt-0">
              <span
                class="wop-description"
                [innerHTML]="data.description | normalizeNewLines | newLineBreaker | nullAsWhatever : '-'"></span>
            </div>
          </ng-template>
        </li>
        <!-- DESCRIPTION -->

        <!-- EQUIPMENT TAG -->
        <li [ngbNavItem]="2">
          <a ngbNavLink class="text-dark font-weight-bold">Equipment Tag</a>
          <ng-template ngbNavContent>
            <div [ngClass]="{'pt-3 pe-3 px-3 pb-0 mt-0': true, 'scrollable-container': true}">
              @if (data.equipment_tags.length > 0) {
                <table class="table table-borderless mb-0 transparent-head">
                  <thead>
                  <tr>
                    <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">TagName</th>
                    <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Description</th>
                  </tr>
                  </thead>
                  <tbody>
                  @for (equipmentTag of data.equipment_tags; track equipmentTag.tag + '-' + $index) {
                    <tr>
                      <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          <span class="clickable" (click)="onDataCardDrawerOpen(equipmentTag.tag)">
                            {{ equipmentTag.tag }}
                          </span>
                      </td>
                      <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                        {{ equipmentTag.description | nullAsWhatever : '-' }}
                      </td>
                    </tr>
                  }
                  </tbody>
                </table>
              }
            </div>
          </ng-template>
        </li>
        <!-- EQUIPMENT TAG -->
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-0"></div>
    </div>
    <!-- -->
  </div>
}
